"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var SecondaryAmount = function SecondaryAmount(_ref) {
  var hasSubmitted = _ref.hasSubmitted,
    payees = _ref.payees,
    payeeAmounts = _ref.payeeAmounts;
  if (hasSubmitted && payees && payees.length > 1) {
    return payees.some(function (_ref2) {
      var id = _ref2.id,
        clientId = _ref2.clientId;
      return !payeeAmounts[id || clientId];
    }) && /*#__PURE__*/_react.default.createElement("div", {
      className: "revision-validation"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "revision-validation--error"
    }, "Invalid amount entered for payee"));
  }
  return null;
};
SecondaryAmount.propTypes = {
  hasSubmitted: _propTypes.default.bool,
  payees: _propTypes.default.object,
  payeeAmounts: _propTypes.default.object
};
var _default = SecondaryAmount;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions-v2/dist/pf-revisions.scss');